export const TRANSLATIONS_DE = {
    auth: {
        marbles: "Marbles",
        prize: "200,000 USD IN PRIZES",
        title: "Bet BNB - Get SQM",
        startBy: "Start by connecting your wallet",
        connect: "Connect Wallet",
        incorrectNetwork: {
            title: "Incorrect Network",
            description: "To play Squid Moon games your wallet needs to be on Binance Smart Chain network",
            switch: "Switch Network"
        }
    },
    header: {
        rank: "Rank",
        payout: "Est. Payout",
        connect: "Connect Wallet",
        prize: "USD IN PRIZES",
        marbles: "Marbles"
    },
    modals: {
        gameStart: {
            calculate: "The marbles are being calculated",
            takeUp: "This normally takes 30 seconds but could be 1-2 minutes",
            playAgain: "Play again",
            close: "You may close this window and keep playing",
            reimburse: "It is very rare for the bet resolution to fail but if this occurs contact our team and provide your betId of: "
        },
        lost: {
            bet: "Your Bet:",
            result: "Result:",
            betterLuck: "Unfortunately you lost, better luck next time"
        },
        marble: {
            marbles: "Marbles",
            yourBet: "Place your bet in BNB then guess if there is an even number or odd number of marbles.",
            win: "If you win, you will receive back your initial bet of BNB",
            reward: "You are given a reward equal to your bet in BNB in $SQM tokens",
            leaderboard: "You move up in the leaderboard",
            lose: "If you are wrong you lose your bet in BNB, your BNB is added to the prize pool, your score does not increase"
        },
        noMarble: {
            result: "Result:",
            noMarbles: "No marbles",
            partialRefund: "There was no marbles in your hand, you get back 50% of your bet"
        },
        selectWallet: {
            connect: "Connect your wallet"
        },
        win: {
            bet: "Your Bet:",
            result: "Result:",
            congrats: "Congratulations for your win"
        },
        end: {
            gameOver: "GAME OVER",
            claim: "Claim Winnings",
            payout: "Estimated Payout",
            distributing: "Distributing..."
        }
    },
    preLoader: {
        title: "Present the first game",
        description: "Place your bet in BNB then guess if there is an even number or odd number of marbles."
    },
    sections: {
        hero: {
            marbles: "Marbles",
            prize: "USD IN PRIZES",
            even: "Even",
            odd: "Odd",
            betAmount: "Choose bet amount to play",
            approve: "Approve the transaction",
            throughWallet: "through your wallet",
            waiting: "Waiting for tx confirmation",
            confirm: "Transaction confirmed. Waiting for bet resolution...",
            description: "Squid Moon games are decentralized apps on the BSC blockchain. You can view the smart contract",
            here: "here",
            failed: "Failed",
            notApproved: "Transaction was not approved",
            close: "Close",
            pending: "Pending",
            or: "OR",
            bnbAmount: "Select BNB amount",
            quickPlay: "Enable Quickplay",
            notEnough: "You do not have enough BNB in your wallet to place a bet."
        },
        leaderboard: {
            leaderboard: "Leaderboard",
            top: "Top",
            winner: "Winner",
            yourScore: "Your score",
            prize: "usd in prizes",
            announced: "days untill the winners announced",
            rank: "Rank",
            score: "Score",
            payout: "Estimated Payout",
            fullLeaderboard: "See full leaderboard",
        },
        prevGame: {
            yourGames: "Your previous games",
            bet: "Bet:",
            result: "Result",
            pending: "Pending",
            win: "Won",
            lost: "Lost",
            none: "Draw",
        }
    }
};
